/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBSTANDBYLIST, GETPERIOD } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBSTANDBYLIST:
      return Object.assign({}, state, { standbyList: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubStandby/reduce.js